export const productsLanguage = {
    en: {
        'Variation Required': 'Variation Required',
        'This is a source': 'This is a source',
        'Variation': 'Variation',
        'Product Number': 'Product Number',
        'Product Name': 'Product Name',
        'Clear': 'Clear',
        'Edit': 'Edit',
        'Add': 'Add',
        'Warning': 'Warning',
        'Cannot select source product.': 'Cannot select source product.',
        'This product is already selected.': 'This product is already selected.',
        'Auto-stock': 'Auto-stock',
        'Returns can be restocked': 'Returns can be restocked',
        'Stock Source': 'Stock Source',
        'Stock Location': 'Stock Location',
        'Stock Low Watermark': 'Stock Low Watermark',
        'Stock High Watermark': 'Stock High Watermark',
        'Sale to Stock Unit Ratio': 'Sale to Stock Unit Ratio',
        'Current Stock Level': 'Current Stock Level',
        'Sale Unit': 'Sale Unit',
        'Stock Unit': 'Stock Unit',
        'Individually': 'Individually',
        'Gram': 'Gram (g)',
        'Kilogram': 'Kilogram (kg)',
        'Milligram': 'Milligram (mg)',
        'Ounce': 'Ounce (oz)',
        'Pound': 'Pound (lb)',
        'Carat': 'Carat (ct)',
        'Threshold': 'Threshold',
        'Name': 'Name',
        'Label': 'Label',
        'Preset Item': 'Preset Item',
        'Qty': 'Qty',
        'Price': 'Price',
        'Group': 'Group',
        'Allow Reduction': 'Allow Reduction',
        'Add Set Item': 'Add Set Item',
        'Remove': 'Remove',
        'Base Price': 'Base Price',
        'Product Group': 'Product Group',
    },
    th: {
        'Variation Required': 'จำเป็นต้องเลือกตัวเลือก',
        'This is a source': 'นี่คือต้นทาง',
        'Variation': 'ตัวเลือก',
        'Product Number': 'รหัสสินค้า',
        'Product Name': 'ชื่อสินค้า',
        'Clear': 'ล้าง',
        'Edit': 'แก้ไข',
        'Add': 'เพิ่ม',
        'Warning': 'คำเตือน',
        'Cannot select source product.': 'ไม่สามารถเลือกสินค้าต้นทางได้',
        'This product is already selected.': 'สินค้านี้ถูกเลือกแล้ว',
        'Auto-stock': 'สต็อกอัตโนมัติ',
        'Returns can be restocked': 'สามารถคืนสินค้าเข้าสต็อกได้',
        'Stock Source': 'แหล่งสต็อก',
        'Stock Location': 'ตำแหน่งสต็อก',
        'Stock Low Watermark': 'จุดเตือนสต็อกต่ำ',
        'Stock High Watermark': 'จุดเตือนสต็อกสูง',
        'Sale to Stock Unit Ratio': 'อัตราส่วนหน่วยขายต่อสต็อก',
        'Current Stock Level': 'ระดับสต็อกปัจจุบัน',
        'Sale Unit': 'หน่วยขาย',
        'Stock Unit': 'หน่วยสต็อก',
        'Individually': 'ชิ้น',
        'Gram': 'กรัม (g)',
        'Kilogram': 'กิโลกรัม (kg)',
        'Milligram': 'มิลลิกรัม (mg)',
        'Ounce': 'ออนซ์ (oz)',
        'Pound': 'ปอนด์ (lb)',
        'Carat': 'กะรัต (ct)',
        'Threshold': 'เกณฑ์',
        'Name': 'ชื่อ',
        'Label': 'ป้ายกำกับ',
        'Preset Item': 'รายการสำเร็จรูป',
        'Qty': 'จำนวน',
        'Price': 'ราคา',
        'Group': 'กลุ่ม',
        'Allow Reduction': 'อนุญาตให้ลด',
        'Add Set Item': 'เพิ่มชุดรายการ',
        'Remove': 'ลบ',
        'Base Price': 'ราคาตั้งต้น',
        'Product Group': 'กลุ่มสินค้า',
    },
    cn: {
        'Variation Required': '需要选择变体',
        'This is a source': '这是源产品',
        'Variation': '变体',
        'Product Number': '产品编号',
        'Product Name': '产品名称',
        'Clear': '清除',
        'Edit': '编辑',
        'Add': '添加',
        'Warning': '警告',
        'Cannot select source product.': '无法选择源产品。',
        'This product is already selected.': '该产品已被选择。',
        'Auto-stock': '自动库存',
        'Returns can be restocked': '退货可补充库存',
        'Stock Source': '库存来源',
        'Stock Location': '库存位置',
        'Stock Low Watermark': '库存下限',
        'Stock High Watermark': '库存上限',
        'Sale to Stock Unit Ratio': '销售与库存单位比',
        'Current Stock Level': '当前库存水平',
        'Sale Unit': '销售单位',
        'Stock Unit': '库存单位',
        'Individually': '单个',
        'Gram': '克 (g)',
        'Kilogram': '千克 (kg)',
        'Milligram': '毫克 (mg)',
        'Ounce': '盎司 (oz)',
        'Pound': '磅 (lb)',
        'Carat': '克拉 (ct)',
        'Threshold': '阈值',
        'Name': '名称',
        'Label': '标签',
        'Preset Item': '预设项',
        'Qty': '数量',
        'Price': '价格',
        'Group': '组',
        'Allow Reduction': '允许减少',
        'Add Set Item': '添加套装项',
        'Remove': '移除',
        'Base Price': '基础价格',
        'Product Group': '产品组',
    },
    jp: {
        'Variation Required': 'バリエーション必須',
        'This is a source': 'これはソースです',
        'Variation': 'バリエーション',
        'Product Number': '商品番号',
        'Product Name': '商品名',
        'Clear': 'クリア',
        'Edit': '編集',
        'Add': '追加',
        'Warning': '警告',
        'Cannot select source product.': 'ソース商品は選択できません。',
        'This product is already selected.': 'この商品はすでに選択されています。',
        'Auto-stock': '自動在庫',
        'Returns can be restocked': '返品は在庫に戻せます',
        'Stock Source': '在庫元',
        'Stock Location': '在庫場所',
        'Stock Low Watermark': '在庫下限',
        'Stock High Watermark': '在庫上限',
        'Sale to Stock Unit Ratio': '販売単位と在庫単位の比率',
        'Current Stock Level': '現在の在庫レベル',
        'Sale Unit': '販売単位',
        'Stock Unit': '在庫単位',
        'Individually': '個別',
        'Gram': 'グラム (g)',
        'Kilogram': 'キログラム (kg)',
        'Milligram': 'ミリグラム (mg)',
        'Ounce': 'オンス (oz)',
        'Pound': 'ポンド (lb)',
        'Carat': 'カラット (ct)',
        'Threshold': 'しきい値',
        'Name': '名前',
        'Label': 'ラベル',
        'Preset Item': 'プリセット項目',
        'Qty': '数量',
        'Price': '価格',
        'Group': 'グループ',
        'Allow Reduction': '減少を許可',
        'Add Set Item': 'セット項目を追加',
        'Remove': '削除',
        'Base Price': '基本価格',
        'Product Group': '商品グループ',
    },
    kr: {
        'Variation Required': '변형 필수',
        'This is a source': '이것은 소스입니다',
        'Variation': '변형',
        'Product Number': '상품 번호',
        'Product Name': '상품명',
        'Clear': '지우기',
        'Edit': '수정',
        'Add': '추가',
        'Warning': '경고',
        'Cannot select source product.': '소스 상품을 선택할 수 없습니다.',
        'This product is already selected.': '이 상품은 이미 선택되었습니다.',
        'Auto-stock': '자동 재고',
        'Returns can be restocked': '반품 재입고 가능',
        'Stock Source': '재고 소스',
        'Stock Location': '재고 위치',
        'Stock Low Watermark': '재고 하한선',
        'Stock High Watermark': '재고 상한선',
        'Sale to Stock Unit Ratio': '판매/재고 단위 비율',
        'Current Stock Level': '현재 재고 수준',
        'Sale Unit': '판매 단위',
        'Stock Unit': '재고 단위',
        'Individually': '개별',
        'Gram': '그램 (g)',
        'Kilogram': '킬로그램 (kg)',
        'Milligram': '밀리그램 (mg)',
        'Ounce': '온스 (oz)',
        'Pound': '파운드 (lb)',
        'Carat': '캐럿 (ct)',
        'Threshold': '임계값',
        'Name': '이름',
        'Label': '라벨',
        'Preset Item': '프리셋 항목',
        'Qty': '수량',
        'Price': '가격',
        'Group': '그룹',
        'Allow Reduction': '감소 허용',
        'Add Set Item': '세트 항목 추가',
        'Remove': '삭제',
        'Base Price': '기본 가격',
        'Product Group': '상품 그룹',
    }
}

export const productSearchModalLanguage = {
    en: {
        Department: 'Department',
        All: 'All',
        Search: 'Search',
        'Product Name': 'Product Name',
        Qty: 'Qty',
        Price: 'Price',
        Barcode: 'Barcode',
        'No matching records found': 'No matching records found',
        Select: 'Select',
        Cancel: 'Cancel',
        'records per page': 'records per page',
        'Page': 'Page',
    },
    th: {
        Department: 'แผนก',
        All: 'ทั้งหมด',
        Search: 'ค้นหา',
        'Product Name': 'ชื่อสินค้า',
        Qty: 'จำนวน',
        Price: 'ราคา',
        Barcode: 'บาร์โค้ด',
        'No matching records found': 'ไม่พบข้อมูลที่ตรงกัน',
        Select: 'เลือก',
        Cancel: 'ยกเลิก',
        'records per page': 'รายการต่อหน้า',
        'Page': 'หน้า',
    },
    cn: {
        Department: '部门',
        All: '全部',
        Search: '搜索',
        'Product Name': '产品名称',
        Qty: '数量',
        Price: '价格',
        Barcode: '条码',
        'No matching records found': '未找到匹配的记录',
        Select: '选择',
        Cancel: '取消',
        'records per page': '每页记录数',
        'Page': '页',
    },
    jp: {
        Department: '部門',
        All: 'すべて',
        Search: '検索',
        'Product Name': '商品名',
        Qty: '数量',
        Price: '価格',
        Barcode: 'バーコード',
        'No matching records found': '一致するレコードがありません',
        Select: '選択',
        Cancel: 'キャンセル',
        'records per page': 'ページあたりの件数',
        'Page': 'ページ',
    },
    kr: {
        Department: '부서',
        All: '전체',
        Search: '검색',
        'Product Name': '상품명',
        Qty: '수량',
        Price: '가격',
        Barcode: '바코드',
        'No matching records found': '일치하는 레코드가 없습니다',
        Select: '선택',
        Cancel: '취소',
        'records per page': '페이지당 항목 수',
        'Page': '페이지',
    }
}

export const productScaleLanguage = {
    en: {
        'Scale Item': 'Scale Item',
        'Stock Low Watermark': 'Stock Low Watermark',
        'Stock High Watermark': 'Stock High Watermark',
        'Sale to Stock Unit Ratio': 'Sale to Stock Unit Ratio',
        'Threshold': 'Threshold',
    },
    th: {
        'Scale Item': 'ชั่งน้ำหนัก',
        'Stock Low Watermark': 'จุดเตือนสต็อกต่ำ',
        'Stock High Watermark': 'จุดเตือนสต็อกสูง',
        'Sale to Stock Unit Ratio': 'อัตราส่วนหน่วยขายต่อสต็อก',
        'Threshold': 'เกณฑ์',
    },
    cn: {
        'Scale Item': '称重商品',
        'Stock Low Watermark': '库存下限',
        'Stock High Watermark': '库存上限',
        'Sale to Stock Unit Ratio': '销售与库存单位比',
        'Threshold': '阈值',
    },
    jp: {
        'Scale Item': '計量商品',
        'Stock Low Watermark': '在庫下限',
        'Stock High Watermark': '在庫上限',
        'Sale to Stock Unit Ratio': '販売単位と在庫単位の比率',
        'Threshold': 'しきい値',
    },
    kr: {
        'Scale Item': '저울 상품',
        'Stock Low Watermark': '재고 하한선',
        'Stock High Watermark': '재고 상한선',
        'Sale to Stock Unit Ratio': '판매/재고 단위 비율',
        'Threshold': '임계값',
    }
}

export const productPriceLevelsLanguage = {
    en: {
        Level: 'Level',
        Price: 'Price',
        HALO: 'HALO',
        LALO: 'LALO',
        'Add Price Level': 'Add Price Level',
    },
    th: {
        Level: 'ระดับ',
        Price: 'ราคา',
        HALO: 'ราคาสูงสุด (HALO)',
        LALO: 'ราคาต่ำสุด (LALO)',
        'Add Price Level': 'เพิ่มระดับราคา',
    },
    cn: {
        Level: '级别',
        Price: '价格',
        HALO: '最高价 (HALO)',
        LALO: '最低价 (LALO)',
        'Add Price Level': '添加价格级别',
    },
    jp: {
        Level: 'レベル',
        Price: '価格',
        HALO: '最高価格 (HALO)',
        LALO: '最低価格 (LALO)',
        'Add Price Level': '価格レベルを追加',
    },
    kr: {
        Level: '레벨',
        Price: '가격',
        HALO: '최고가 (HALO)',
        LALO: '최저가 (LALO)',
        'Add Price Level': '가격 레벨 추가',
    }
}

export const productMiscellaneousLanguage = {
    en: {
        'Memo Required': 'Memo Required',
        'Memo': 'Memo',
        'Name': 'Name',
        'Age Verification Required': 'Age Verification Required',
        'No Membership Discount Allowed': 'No Membership Discount Allowed',
        'Non Discountable': 'Non Discountable',
        'Non Surchargeable': 'Non Surchargeable',
    },
    th: {
        'Memo Required': 'ต้องระบุหมายเหตุ',
        'Memo': 'หมายเหตุ',
        'Name': 'ชื่อ',
        'Age Verification Required': 'ต้องตรวจสอบอายุ',
        'No Membership Discount Allowed': 'ไม่อนุญาตส่วนลดสมาชิก',
        'Non Discountable': 'ไม่สามารถลดราคาได้',
        'Non Surchargeable': 'ไม่สามารถคิดค่าบริการเพิ่มได้',
    },
    cn: {
        'Memo Required': '需要备注',
        'Memo': '备注',
        'Name': '名称',
        'Age Verification Required': '需要年龄验证',
        'No Membership Discount Allowed': '不允许会员折扣',
        'Non Discountable': '不可打折',
        'Non Surchargeable': '不可加收附加费',
    },
    jp: {
        'Memo Required': 'メモ必須',
        'Memo': 'メモ',
        'Name': '名前',
        'Age Verification Required': '年齢確認が必要',
        'No Membership Discount Allowed': '会員割引不可',
        'Non Discountable': '割引不可',
        'Non Surchargeable': '追加料金不可',
    },
    kr: {
        'Memo Required': '메모 필수',
        'Memo': '메모',
        'Name': '이름',
        'Age Verification Required': '연령 확인 필요',
        'No Membership Discount Allowed': '멤버십 할인 불가',
        'Non Discountable': '할인 불가',
        'Non Surchargeable': '추가 요금 불가',
    }
}

export const productListTableLanguage = {
    en: {
        Department: 'Department',
        All: 'All',
        Search: 'Search',
        'Add Product': 'Add Product +',
        'Product Name': 'Product Name',
        Qty: 'Qty',
        Price: 'Price',
        Barcode: 'Barcode',
        'No matching records found': 'No matching records found',
    },
    th: {
        Department: 'แผนก',
        All: 'ทั้งหมด',
        Search: 'ค้นหา',
        'Add Product': 'เพิ่มสินค้า +',
        'Product Name': 'ชื่อสินค้า',
        Qty: 'จำนวน',
        Price: 'ราคา',
        Barcode: 'บาร์โค้ด',
        'No matching records found': 'ไม่พบข้อมูลที่ตรงกัน',
    },
    cn: {
        Department: '部门',
        All: '全部',
        Search: '搜索',
        'Add Product': '添加产品 +',
        'Product Name': '产品名称',
        Qty: '数量',
        Price: '价格',
        Barcode: '条码',
        'No matching records found': '未找到匹配的记录',
    },
    jp: {
        Department: '部門',
        All: 'すべて',
        Search: '検索',
        'Add Product': '商品追加 +',
        'Product Name': '商品名',
        Qty: '数量',
        Price: '価格',
        Barcode: 'バーコード',
        'No matching records found': '一致するレコードがありません',
    },
    kr: {
        Department: '부서',
        All: '전체',
        Search: '검색',
        'Add Product': '상품 추가 +',
        'Product Name': '상품명',
        Qty: '수량',
        Price: '가격',
        Barcode: '바코드',
        'No matching records found': '일치하는 레코드가 없습니다',
    }
}

export const productLinkGroupsLanguage = {
    en: {
        'Product Group': 'Product Group',
    },
    th: {
        'Product Group': 'กลุ่มสินค้า',
    },
    cn: {
        'Product Group': '产品组',
    },
    jp: {
        'Product Group': '商品グループ',
    },
    kr: {
        'Product Group': '상품 그룹',
    }
}

export const productGroupSearchModalLanguage = {
    en: {
        'Product Group': 'Product Group',
        Select: 'Select',
        Cancel: 'Cancel',
    },
    th: {
        'Product Group': 'กลุ่มสินค้า',
        Select: 'เลือก',
        Cancel: 'ยกเลิก',
    },
    cn: {
        'Product Group': '产品组',
        Select: '选择',
        Cancel: '取消',
    },
    jp: {
        'Product Group': '商品グループ',
        Select: '選択',
        Cancel: 'キャンセル',
    },
    kr: {
        'Product Group': '상품 그룹',
        Select: '선택',
        Cancel: '취소',
    }
}

export const productFilterLanguage = {
    en: {
        'Add Product': 'Add Product',
        'Product': 'Product',
        'Category': 'Category',
        'Subcategory': 'Subcategory',
        'Status': 'Status',
        'Price': 'Price',
        'Select Product': 'Select Product',
        'Select Category': 'Select Category',
        'Select Subcategory': 'Select Subcategory',
        'Select Status': 'Select Status',
        'Select Price': 'Select Price',
        'Filter': 'Filter',
        'Collapse': 'Collapse',
    },
    th: {
        'Add Product': 'เพิ่มสินค้า',
        'Product': 'สินค้า',
        'Category': 'หมวดหมู่',
        'Subcategory': 'หมวดหมู่ย่อย',
        'Status': 'สถานะ',
        'Price': 'ราคา',
        'Select Product': 'เลือกสินค้า',
        'Select Category': 'เลือกหมวดหมู่',
        'Select Subcategory': 'เลือกหมวดหมู่ย่อย',
        'Select Status': 'เลือกสถานะ',
        'Select Price': 'เลือกราคา',
        'Filter': 'กรอง',
        'Collapse': 'ย่อ',
    },
    cn: {
        'Add Product': '添加产品',
        'Product': '产品',
        'Category': '类别',
        'Subcategory': '子类别',
        'Status': '状态',
        'Price': '价格',
        'Select Product': '选择产品',
        'Select Category': '选择类别',
        'Select Subcategory': '选择子类别',
        'Select Status': '选择状态',
        'Select Price': '选择价格',
        'Filter': '筛选',
        'Collapse': '收起',
    },
    jp: {
        'Add Product': '商品追加',
        'Product': '商品',
        'Category': 'カテゴリ',
        'Subcategory': 'サブカテゴリ',
        'Status': 'ステータス',
        'Price': '価格',
        'Select Product': '商品を選択',
        'Select Category': 'カテゴリを選択',
        'Select Subcategory': 'サブカテゴリを選択',
        'Select Status': 'ステータスを選択',
        'Select Price': '価格を選択',
        'Filter': 'フィルター',
        'Collapse': '折りたたむ',
    },
    kr: {
        'Add Product': '상품 추가',
        'Product': '상품',
        'Category': '카테고리',
        'Subcategory': '하위 카테고리',
        'Status': '상태',
        'Price': '가격',
        'Select Product': '상품 선택',
        'Select Category': '카테고리 선택',
        'Select Subcategory': '하위 카테고리 선택',
        'Select Status': '상태 선택',
        'Select Price': '가격 선택',
        'Filter': '필터',
        'Collapse': '접기',
    }
}

export const productDetailsLanguage = {
    en: {
        'Product List': 'Product List',
        Basic: 'Basic',
        Stock: 'Stock',
        Scale: 'Scale',
        'Set Items': 'Set Items',
        Appearance: 'Appearance',
        'Price Levels': 'Price Levels',
        Condiments: 'Condiments',
        'Link Groups': 'Link Groups',
        Variation: 'Variation',
        Miscellaneous: 'Miscellaneous',
        'Modify / Save': 'Modify / Save',
        Delete: 'Delete',
        'Are you sure?': 'Are you sure?',
        "You won't be able to revert this!": "You won't be able to revert this!",
        Confirm: 'Confirm',
        success: 'Success!',
        'Tax details updated successfully': 'Tax details updated successfully',
        'Deleted!': 'Deleted!',
        'Your file has been deleted.': 'Your file has been deleted.',
    },
    th: {
        'Product List': 'รายการสินค้า',
        Basic: 'ข้อมูลพื้นฐาน',
        Stock: 'สต็อก',
        Scale: 'ชั่งน้ำหนัก',
        'Set Items': 'ชุดรายการ',
        Appearance: 'ลักษณะ',
        'Price Levels': 'ระดับราคา',
        Condiments: 'เครื่องปรุง',
        'Link Groups': 'กลุ่มลิงก์',
        Variation: 'ตัวเลือก',
        Miscellaneous: 'เบ็ดเตล็ด',
        'Modify / Save': 'แก้ไข / บันทึก',
        Delete: 'ลบ',
        'Are you sure?': 'คุณแน่ใจหรือไม่?',
        "You won't be able to revert this!": "คุณจะไม่สามารถย้อนกลับได้!",
        Confirm: 'ยืนยัน',
        success: 'สำเร็จ!',
        'Tax details updated successfully': 'อัปเดตรายละเอียดภาษีสำเร็จ',
        'Deleted!': 'ลบแล้ว!',
        'Your file has been deleted.': 'ไฟล์ของคุณถูกลบแล้ว',
    },
    cn: {
        'Product List': '产品列表',
        Basic: '基本信息',
        Stock: '库存',
        Scale: '称重',
        'Set Items': '套装项目',
        Appearance: '外观',
        'Price Levels': '价格级别',
        Condiments: '调味品',
        'Link Groups': '链接组',
        Variation: '变体',
        Miscellaneous: '杂项',
        'Modify / Save': '修改 / 保存',
        Delete: '删除',
        'Are you sure?': '你确定吗？',
        "You won't be able to revert this!": "此操作无法撤销！",
        Confirm: '确认',
        success: '成功！',
        'Tax details updated successfully': '税务详情更新成功',
        'Deleted!': '已删除！',
        'Your file has been deleted.': '您的文件已被删除。',
    },
    jp: {
        'Product List': '商品リスト',
        Basic: '基本情報',
        Stock: '在庫',
        Scale: '計量',
        'Set Items': 'セット項目',
        Appearance: '外観',
        'Price Levels': '価格レベル',
        Condiments: '調味料',
        'Link Groups': 'リンクグループ',
        Variation: 'バリエーション',
        Miscellaneous: 'その他',
        'Modify / Save': '修正 / 保存',
        Delete: '削除',
        'Are you sure?': 'よろしいですか？',
        "You won't be able to revert this!": "この操作は元に戻せません！",
        Confirm: '確認',
        success: '成功！',
        'Tax details updated successfully': '税詳細が正常に更新されました',
        'Deleted!': '削除されました！',
        'Your file has been deleted.': 'ファイルが削除されました。',
    },
    kr: {
        'Product List': '상품 목록',
        Basic: '기본 정보',
        Stock: '재고',
        Scale: '저울',
        'Set Items': '세트 항목',
        Appearance: '외관',
        'Price Levels': '가격 레벨',
        Condiments: '조미료',
        'Link Groups': '링크 그룹',
        Variation: '변형',
        Miscellaneous: '기타',
        'Modify / Save': '수정 / 저장',
        Delete: '삭제',
        'Are you sure?': '확실합니까?',
        "You won't be able to revert this!": "이 작업은 되돌릴 수 없습니다!",
        Confirm: '확인',
        success: '성공!',
        'Tax details updated successfully': '세금 세부정보가 성공적으로 업데이트되었습니다',
        'Deleted!': '삭제됨!',
        'Your file has been deleted.': '파일이 삭제되었습니다.',
    }
}

export const productCondimentsLanguage = {
    en: {
        'Condiments required': 'Condiments required',
        'Reorder': 'Reorder',
    },
    th: {
        'Condiments required': 'ต้องเลือกเครื่องปรุง',
        'Reorder': 'จัดเรียงใหม่',
    },
    cn: {
        'Condiments required': '需要选择调味品',
        'Reorder': '重新排序',
    },
    jp: {
        'Condiments required': '調味料必須',
        'Reorder': '並べ替え',
    },
    kr: {
        'Condiments required': '조미료 필수',
        'Reorder': '재정렬',
    }
}

export const productBasicLanguage = {
    en: {
        'Product Number': 'Product Number',
        Department: 'Department',
        'Product Name': 'Product Name',
        Barcode: 'Barcode',
        'Tax Rate': 'Tax Rate',
        'Service Charge': 'Service Charge',
        'Alternative Product Name': 'Alternative Product Name',
        'Alternative Product Name 2': 'Alternative Product Name 2',
        'Alternative Display Language': 'Alternative Display Language',
        'Display Order': 'Display Order',
        'Empty Button': 'Empty Button',
        'Single Item Select': 'Single Item Select',
        'Show on Menu': 'Show on Menu',
        Name: 'Name',
        Threshold: 'Threshold',
    },
    th: {
        'Product Number': 'รหัสสินค้า',
        Department: 'แผนก',
        'Product Name': 'ชื่อสินค้า',
        Barcode: 'บาร์โค้ด',
        'Tax Rate': 'อัตราภาษี',
        'Service Charge': 'ค่าบริการ',
        'Alternative Product Name': 'ชื่อสินค้าเพิ่มเติม',
        'Alternative Product Name 2': 'ชื่อสินค้าเพิ่มเติม 2',
        'Alternative Display Language': 'ภาษาแสดงผลเพิ่มเติม',
        'Display Order': 'ลำดับการแสดงผล',
        'Empty Button': 'ปุ่มว่าง',
        'Single Item Select': 'เลือกสินค้าชิ้นเดียว',
        'Show on Menu': 'แสดงในเมนู',
        Name: 'ชื่อ',
        Threshold: 'เกณฑ์',
    },
    cn: {
        'Product Number': '产品编号',
        Department: '部门',
        'Product Name': '产品名称',
        Barcode: '条码',
        'Tax Rate': '税率',
        'Service Charge': '服务费',
        'Alternative Product Name': '备用产品名称',
        'Alternative Product Name 2': '备用产品名称2',
        'Alternative Display Language': '备用显示语言',
        'Display Order': '显示顺序',
        'Empty Button': '空按钮',
        'Single Item Select': '单项选择',
        'Show on Menu': '在菜单中显示',
        Name: '名称',
        Threshold: '阈值',
    },
    jp: {
        'Product Number': '商品番号',
        Department: '部門',
        'Product Name': '商品名',
        Barcode: 'バーコード',
        'Tax Rate': '税率',
        'Service Charge': 'サービス料',
        'Alternative Product Name': '代替商品名',
        'Alternative Product Name 2': '代替商品名2',
        'Alternative Display Language': '代替表示言語',
        'Display Order': '表示順',
        'Empty Button': '空ボタン',
        'Single Item Select': '単一商品選択',
        'Show on Menu': 'メニューに表示',
        Name: '名前',
        Threshold: 'しきい値',
    },
    kr: {
        'Product Number': '상품 번호',
        Department: '부서',
        'Product Name': '상품명',
        Barcode: '바코드',
        'Tax Rate': '세율',
        'Service Charge': '서비스 요금',
        'Alternative Product Name': '대체 상품명',
        'Alternative Product Name 2': '대체 상품명 2',
        'Alternative Display Language': '대체 표시 언어',
        'Display Order': '표시 순서',
        'Empty Button': '빈 버튼',
        'Single Item Select': '단일 상품 선택',
        'Show on Menu': '메뉴에 표시',
        Name: '이름',
        Threshold: '임계값',
    }
}

export const productAppearanceLanguage = {
    en: {
        NoImage: 'No Image',
        UploadImage: 'Upload Image',
        RemoveImage: 'Remove Image',
        ButtonColor: 'Button Color',
        ButtonFontSize: 'Button Font Size',
        XLarge: 'X-Large',
        Large: 'Large',
        Medium: 'Medium',
        Small: 'Small',
        Red: 'Red',
        Green: 'Green',
        Blue: 'Blue',
        Yellow: 'Yellow',
        Cyan: 'Cyan',
        Magenta: 'Magenta',
        Orange: 'Orange',
        Purple: 'Purple',
        Brown: 'Brown',
        Pink: 'Pink',
        Lime: 'Lime',
        Teal: 'Teal',
    },
    th: {
        NoImage: 'ไม่มีรูปภาพ',
        UploadImage: 'อัปโหลดรูปภาพ',
        RemoveImage: 'ลบรูปภาพ',
        ButtonColor: 'สีปุ่ม',
        ButtonFontSize: 'ขนาดตัวอักษรปุ่ม',
        XLarge: 'ขนาดใหญ่มาก',
        Large: 'ขนาดใหญ่',
        Medium: 'ขนาดกลาง',
        Small: 'ขนาดเล็ก',
        Red: 'แดง',
        Green: 'เขียว',
        Blue: 'น้ำเงิน',
        Yellow: 'เหลือง',
        Cyan: 'ฟ้า',
        Magenta: 'ม่วงแดง',
        Orange: 'ส้ม',
        Purple: 'ม่วง',
        Brown: 'น้ำตาล',
        Pink: 'ชมพู',
        Lime: 'เขียวอ่อน',
        Teal: 'เขียวอมฟ้า',
    },
    cn: {
        NoImage: '无图片',
        UploadImage: '上传图片',
        RemoveImage: '移除图片',
        ButtonColor: '按钮颜色',
        ButtonFontSize: '按钮字体大小',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '红色',
        Green: '绿色',
        Blue: '蓝色',
        Yellow: '黄色',
        Cyan: '青色',
        Magenta: '品红',
        Orange: '橙色',
        Purple: '紫色',
        Brown: '棕色',
        Pink: '粉色',
        Lime: '酸橙色',
        Teal: '蓝绿色',
    },
    kr: {
        NoImage: '이미지 없음',
        UploadImage: '이미지 업로드',
        RemoveImage: '이미지 제거',
        ButtonColor: '버튼 색상',
        ButtonFontSize: '버튼 글꼴 크기',
        XLarge: '특대',
        Large: '대',
        Medium: '중',
        Small: '소',
        Red: '빨강',
        Green: '초록',
        Blue: '파랑',
        Yellow: '노랑',
        Cyan: '청록',
        Magenta: '마젠타',
        Orange: '주황',
        Purple: '보라',
        Brown: '갈색',
        Pink: '분홍',
        Lime: '라임',
        Teal: '청록색',
    },
    jp: {
        NoImage: '画像なし',
        UploadImage: '画像をアップロード',
        RemoveImage: '画像を削除',
        ButtonColor: 'ボタンの色',
        ButtonFontSize: 'ボタンのフォントサイズ',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '赤',
        Green: '緑',
        Blue: '青',
        Yellow: '黄',
        Cyan: 'シアン',
        Magenta: 'マゼンタ',
        Orange: 'オレンジ',
        Purple: '紫',
        Brown: '茶色',
        Pink: 'ピンク',
        Lime: 'ライム',
        Teal: 'ティール',
    },
}

export const productAltLangModalLanguage = {
    en: {
        'Alternative Display Language': 'Alternative Display Language',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        'Alternative Display Language': 'ภาษาแสดงผลเพิ่มเติม',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        'Alternative Display Language': '备用显示语言',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        'Alternative Display Language': '代替表示言語',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        'Alternative Display Language': '대체 표시 언어',
        OK: '확인',
        Cancel: '취소',
    }
}

export const productAddSetItemModalLanguage = {
    en: {
        'Set Item': 'Set Item',
        'Label': 'Label',
        'OK': 'OK',
        'Cancel': 'Cancel',
    },
    th: {
        'Set Item': 'ชุดรายการ',
        'Label': 'ป้ายกำกับ',
        'OK': 'ตกลง',
        'Cancel': 'ยกเลิก',
    },
    cn: {
        'Set Item': '套装项目',
        'Label': '标签',
        'OK': '确定',
        'Cancel': '取消',
    },
    jp: {
        'Set Item': 'セット項目',
        'Label': 'ラベル',
        'OK': 'OK',
        'Cancel': 'キャンセル',
    },
    kr: {
        'Set Item': '세트 항목',
        'Label': '라벨',
        'OK': '확인',
        'Cancel': '취소',
    }
}

export const productAddModalLanguage = {
    en: {
        'New Product Group': 'New Product Group',
        Department: 'Department',
        'Select Department': 'Select Department',
        'Department Name': 'Department Name',
        'Department Number': 'Department Number',
        'Product Number': 'Product Number',
        'Product Name': 'Product Name',
        OK: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        'New Product Group': 'กลุ่มสินค้าใหม่',
        Department: 'แผนก',
        'Select Department': 'เลือกแผนก',
        'Department Name': 'ชื่อแผนก',
        'Department Number': 'หมายเลขแผนก',
        'Product Number': 'รหัสสินค้า',
        'Product Name': 'ชื่อสินค้า',
        OK: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        'New Product Group': '新产品组',
        Department: '部门',
        'Select Department': '选择部门',
        'Department Name': '部门名称',
        'Department Number': '部门编号',
        'Product Number': '产品编号',
        'Product Name': '产品名称',
        OK: '确定',
        Cancel: '取消',
    },
    jp: {
        'New Product Group': '新しい商品グループ',
        Department: '部門',
        'Select Department': '部門を選択',
        'Department Name': '部門名',
        'Department Number': '部門番号',
        'Product Number': '商品番号',
        'Product Name': '商品名',
        OK: 'OK',
        Cancel: 'キャンセル',
    },
    kr: {
        'New Product Group': '새 상품 그룹',
        Department: '부서',
        'Select Department': '부서 선택',
        'Department Name': '부서명',
        'Department Number': '부서 번호',
        'Product Number': '상품 번호',
        'Product Name': '상품명',
        OK: '확인',
        Cancel: '취소',
    }
}